import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import path, { pathMiniGame } from 'src/constants/path'
import { UserInfoCollapse } from 'src/layouts/MainLayout/MainLayout'
import { useCartMiniGameStore } from 'src/libs/hooks/store/useCartMiniGameStore'
import { useCartSportStore } from 'src/libs/hooks/store/useCartSportStore'
import { useViewport } from 'src/libs/hooks/useWindowDimension'
import { RootState } from 'src/libs/utils/store'
import { CloseIcon } from './Icons/CloseIcon'
import SideBarRight from './SideBar/SideBarRight'
import Button from './ui/Button'
import { useCartLiveSportsStore } from 'src/libs/hooks/store/useCartLiveSportsStore'

const shows_path = [path.sports, path.live_sport, ...pathMiniGame]

const ToggleCart = () => {
  const location = useLocation()
  const user = useSelector((state: RootState) => state.auth.user)
  const { isIP, isTablet } = useViewport()

  const [open, setOpen] = useState(false)
  const isShow = shows_path.includes(location.pathname) && (isIP || isTablet)
  const { count: sportCount, cart: cartSports } = useCartSportStore()
  const { count: miniGameCount } = useCartMiniGameStore()
  const { count: liveSportCount } = useCartLiveSportsStore()

  let count = sportCount || miniGameCount || liveSportCount
  if (cartSports.folder_bonus?.key) {
    count++
  }

  if (!isShow || !count) return <></>

  return (
    <>
      <button
        className='trigger-button bg-[#171c22] bg-linear-blue rounded-full p-2 fixed items-center justify-center bottom-4 left-4 z-[999] w-12 h-12 text-primary border border-primary'
        onClick={() => {
          setOpen(!open)
        }}
      >
        <p className='absolute -top-4 -right-2 bg-primary size-8 flex justify-center items-center rounded-full text-white'>
          {count > 99 ? '99+' : count}
        </p>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 24 24'
          width={20}
          height={20}
          fill='currentColor'
          className='right-menu-icon absolute top-3 left-3'
        >
          <path d='M6.00488 9H19.9433L20.4433 7H8.00488V5H21.7241C22.2764 5 22.7241 5.44772 22.7241 6C22.7241 6.08176 22.7141 6.16322 22.6942 6.24254L20.1942 16.2425C20.083 16.6877 19.683 17 19.2241 17H5.00488C4.4526 17 4.00488 16.5523 4.00488 16V4H2.00488V2H5.00488C5.55717 2 6.00488 2.44772 6.00488 3V9ZM6.00488 23C4.90031 23 4.00488 22.1046 4.00488 21C4.00488 19.8954 4.90031 19 6.00488 19C7.10945 19 8.00488 19.8954 8.00488 21C8.00488 22.1046 7.10945 23 6.00488 23ZM18.0049 23C16.9003 23 16.0049 22.1046 16.0049 21C16.0049 19.8954 16.9003 19 18.0049 19C19.1095 19 20.0049 19.8954 20.0049 21C20.0049 22.1046 19.1095 23 18.0049 23Z' />
        </svg>
      </button>

      <div
        className={`max-w-[350px] fixed top-0 -right-full z-[999] transition-all h-dvh overflow-scroll  p-4 bg-secondary-2 ${open && 'right-0'}`}
      >
        <Button
          className='ml-auto flex'
          onClick={() => {
            setOpen(!open)
          }}
        >
          <CloseIcon size={20} className='ml-auto' />
        </Button>
        {user && <UserInfoCollapse />}
        <SideBarRight />
      </div>
    </>
  )
}

export default ToggleCart
